import { ConfirmDestructiveDialog } from "~/pages/manifold-nextgen/components/ConfirmDestructiveDialog";

interface DeleteConversationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  conversationTitle: string;
  onConfirm: () => Promise<void>;
}

export const DeleteConversationDialog = ({
  open,
  onOpenChange,
  conversationTitle,
  onConfirm,
}: DeleteConversationDialogProps) => (
  <ConfirmDestructiveDialog
    target={open ? conversationTitle : null}
    title="Delete conversation?"
    description={(title) => (
      <>
        <span className="font-medium text-foreground">{title}</span> will be permanently deleted,
        including all of its messages and artifacts. This cannot be undone.
      </>
    )}
    confirmLabel="Delete"
    pendingLabel="Deleting…"
    onConfirm={onConfirm}
    onClose={() => onOpenChange(false)}
  />
);
